interface PermissionItem {
    role_id: string;
    permission: string;
}

interface PermissionsData {
    item: PermissionItem[];
    permissions: string;
}

const hasPermission = (permissionsJson: string, userRoleId: string): boolean => {
    try {
        const permissionsData: PermissionsData = JSON.parse(permissionsJson);
        // If the item array is empty, allow for all
        if (!permissionsData.item || permissionsData.item.length === 0) {
            return true;
        }
        // Check if any permission in the array matches the userRoleId and allow access if permission is not "none"
        const allowedEntry = permissionsData.item.find(
            (perm) => perm.role_id === userRoleId && perm.permission !== "none"
        );
        return Boolean(allowedEntry);
    } catch (error) {
        console.error("Error parsing permissionsJson:", error);
        return false;
    }
};

export default hasPermission;